import {
  Input,SimpleChanges,OnChanges,
  Component,
  OnInit,ElementRef,ViewContainerRef, Renderer
} from '@angular/core';
import {CompanyService} from "../../services/company-service/company-service";
import {CompanyVM} from "../../models/CompanyVM.model";


@Component({

  selector: 'pl-book-component-vue',  // <home></home>

  styles: [require('./book-component-vue.component.css')],

  template: require('./book-component-vue.component.html')
})

export class BookComponentVueComponent implements OnInit,OnChanges {

   @Input() public startWithServants:string = 'false';
  // @Input() public selectedServant:ServantVM;

  scriptLoaded = false;
  company:CompanyVM ;
  /**
   * TypeScript public modifiers
   */
  constructor(
    private elRef: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private renderer: Renderer, private companyService: CompanyService
  ) {}


  public ngOnInit() {
    this.companyService.getCompanyInfo().subscribe((company) => {
      this.company = company;
      this.loadScript();
    });

  }
  private loadScript() {
    const script = document.createElement("script");
    script.src = process.env.COMPONENT_STARTER_URL;

    const planovinElement = document.createElement("planovin-component");
    planovinElement.setAttribute('url', this.company.keyUrl);
    planovinElement.setAttribute('start-with-servants', this.startWithServants);
    planovinElement.setAttribute('order-bag-display', 'HIDE');
    planovinElement.setAttribute('view-mode', 'minimal');
    planovinElement.setAttribute('show-reservations-list', 'HIDE');
    planovinElement.setAttribute('order-bag-show-place', 'RIGHT');
    planovinElement.setAttribute('payment-return-url', 'NONE');

    this.viewContainerRef.element.nativeElement.appendChild(planovinElement);
    this.elRef.nativeElement.appendChild(script);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let parent = this;
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/book-component-vue/book-component-vue.component.ts